export enum ERequestStatus {
  FULFILLED = "fulfilled",
  PENDING = "pending",
  REJECTED = "rejected",
}
